const listeners = new Set();
export const state = {
  session: null,
  organizationId: null,
  routes: [],
  currentRoute: createEmptyRoute(),
};
export function createEmptyRoute() {
  return {
    id: null,
    versionId: null,
    title: '',
    direction: '',
    sourceFileName: '',
    sourceFile: null,
    originalPoints: [],
    expandedPoints: [],
    routeGeometry: null,
    routeLegs: [],
    sections: [],
    results: {},
    mapScreenshotDataUrl: '',
    dirty: false,
  };
}
export function setState(patch) {
  Object.assign(state, patch);
  listeners.forEach(fn => fn(state));
}
export function updateCurrentRoute(patch) {
  state.currentRoute = { ...state.currentRoute, ...patch, dirty: patch.dirty ?? true };
  listeners.forEach(fn => fn(state));
}
export function subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); }
